

export const customerData = [
    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Closed"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    },

    {
        booking_number:"689643875",
        pickup_time:"Jan 20 11:16:am",
        pickup_location:"Kempegowda International Airport, Bengaluru",
        drop_location:"Kauvery Hospitals, Benguluru",
        status:"Open"
    }
];


export const customerColumns = [

    {
        name: 'BOOKING #',
        selector: row => row['booking_number'],
        sortable: true,
        center: true,
        // width:"130px",
        
    },
    {
        name: 'PICKUP TIME',
        selector: row => row['pickup_time'],
        sortable: true,
        center: true,
        // width:"130px",
    },
    {
        name: 'STATUS',
        selector: row => row['status'],
        sortable: true,
        center: true,
        // width:"100px",
    },
    {
        name: 'PICKUP LOCATION',
        selector: row => row['pickup_location'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    {
        name: 'DROP LOCATION',
        selector: row => row['drop_location'],
        sortable: true,
        center: true,
        // maxWidth:"7vw",
    },
    {
        name: '',
        selector: row => row['action'],
        sortable: true,
        center: true,
        width: "80px"
        // maxWidth:"7vw",
    }
];
